import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";

const mutateAddSafetyChecklist = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${SAFETY_CHECKLIST_API}`, data);
};

const useAddSafetyChecklistMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddSafetyChecklist,
    ...queryParams,
  });

export default useAddSafetyChecklistMutation;
